import React from 'react';
import PropTypes from 'prop-types';

import RadioList from '../RadioList/RadioList';
import Select from '../Select/Select';
import { StyledDiv, StyledLabel } from './ProductVariantSelectorStyles';

var ProductVariantSelector = function ProductVariantSelector(props) {
  var useRadioAry = ['color'];
  var optionName = props.option.name.toLowerCase();
  var useRadio = useRadioAry.includes(optionName);
  var selectedOption = props.selectedOptions[props.option.name]; // can be upper/lower case
  var swatchLabel = optionName === 'color';
  return React.createElement(
    StyledDiv,
    null,
    swatchLabel && React.createElement(
      StyledLabel,
      null,
      'Color: ',
      React.createElement(
        'span',
        null,
        selectedOption
      )
    ),
    useRadio ? React.createElement(RadioList, {
      handleOptionChange: props.handleOptionChange,
      option: props.option,
      selectedOptions: props.selectedOptions,
      selectedOption: selectedOption,
      variants: props.variants,
      productId: props.productId,
      parent: props.parent || 'ProductVariantSelector'
    }) : React.createElement(Select, {
      handleOptionChange: props.handleOptionChange,
      option: props.option,
      selectedOption: selectedOption,
      selectedOptions: props.selectedOptions,
      variants: props.variants
    })
  );
};

ProductVariantSelector.propTypes = {
  option: PropTypes.object.isRequired,
  selectedOptions: PropTypes.object.isRequired,
  variants: PropTypes.array.isRequired,
  productId: PropTypes.string.isRequired,
  parent: PropTypes.string,
  showLabel: PropTypes.bool,
  handleOptionChange: PropTypes.func.isRequired
};

export default React.memo(ProductVariantSelector);